module.exports = __webpack_public_path__ + "img/public/AdminIcons/reportIcon.svg?a195b2e6";